import { translate } from "helpers/i18n";
import { display, removeMessage, updateMessage } from "redux-react/reducers/snackBarReducer";

/**
 * Websocket message handler
 * @param {*} store
 * @param {*} socket
 * @param {*} event
 * @param {*} data
 */
export default function receiveWebsocketMessage({ dispatch, getState }, socket, event, data) {
	switch (event) {
		/**
		 * Snackbar message
		 */
		case "create_snackbar_message": {
			try {
				const message = data.message || "";
				const id = data.id || null;
				const type = data.type || "loading";

				if (!id) {
					return;
				}

				dispatch(
					display({
						id,
						message: translate(message),
						type
					})
				);
			} catch (error) {
				// Do nothing
			}
			break;
		}
		case "update_snackbar_message": {
			try {
				const message = data.message || "";
				const id = data.id || null;
				const finish = data.finish || false;
				const timeout = data.timeout || 3000;
				const type = data.type || "loading";

				if (!id) {
					return;
				}

				dispatch(
					updateMessage({
						id,
						message: translate(message),
						type
					})
				);

				if (finish) {
					setTimeout(() => {
						dispatch(
							removeMessage({
								id
							})
						);
					}, timeout);
				}
			} catch (error) {
				// Do nothing
			}
			break;
		}
		case "remove_snackbar_message": {
			try {
				const id = data.id || null;
				const timeout = data.timeout || 1000;

				if (!id) {
					return;
				}

				setTimeout(() => {
					dispatch(
						removeMessage({
							id
						})
					);
				}, timeout);
			} catch (error) {
				// Do nothing
			}
			break;
		}
		default:
			break;
	}
}
